import './BoothNumberComponent.scss';
import { FC } from 'react';
import { useLocation } from 'react-router';
export interface IBoothNumberComponentProps {
	text: string;
	boothStyle: 'primary' | 'secondary';
	icon: string;
	onClick?: () => void;
}
export const BoothNumberComponent: FC<IBoothNumberComponentProps> = ({
	text,
	boothStyle,
	onClick,
	icon
}) => {
	const location = useLocation();
	const isBrandPage = location.pathname.startsWith('/brand/');
	return (
		<div
			data-testid='booth-number-component'
			className={`booth-number ${boothStyle} ${isBrandPage ? 'booth-number-brand' : ''}`}
			onClick={onClick}
		>
			<span className='booth-text'>{text}</span>
		</div>
	);
};
